import React from 'react';

// Basic result, mostly used for debugging
export var BasicResult = ({ result }) => <p>{JSON.stringify(result)}</p>

// If the opposite is present in the array, remove it; Otherwise add the value
export var removeOppositeOrAddVal = function (arr, oppositeToRemove, valToAdd) {
  if (arr.length > 0 && arr[arr.length - 1] === oppositeToRemove) {
    arr.pop();
  } else {
    arr.push(valToAdd);
  }
}

// Given a result row, and a set of dice types, pull evertying out and flatten them
export var getAllRolledFaces = function(result, diceTypes) {
  var allRolledFaces = [];
  diceTypes.forEach(diceType => {
    if (result[diceType]) {
      result[diceType].forEach(diceFace => {
        allRolledFaces.push(diceFace);
      })
    }
  });

  // Flatten all results (two Adv on same face)
  return allRolledFaces.join('').split('').sort();
};


// WEBPACK FOOTER //
// ./src/RollResults/resultHelpers.js